enum CollectionType{
	All,
	MineOnly,
	SharedWithMe,
	Favourites,
	Public,
	GuestAccess,
	Smart
}